var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIveGreenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0.344 0.156 20 20",
    enableBackground: "new 0.344 0.156 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.3442,
    y1: 30.8438,
    x2: 10.3442,
    y2: 10.8442,
    gradientTransform: "matrix(1 0 0 -1 0 31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#273A4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A2835"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M3.344,0.156h14c1.656,0,3,1.343,3,3v14c0,1.656-1.344,3-3,3h-14c-1.657,0-3-1.344-3-3v-14 C0.344,1.5,1.687,0.156,3.344,0.156z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.04,
    d: "M3.344,0.656h14c1.381,0,2.5,1.119,2.5,2.5v14 c0,1.381-1.119,2.5-2.5,2.5h-14c-1.381,0-2.5-1.119-2.5-2.5v-14C0.844,1.775,1.963,0.656,3.344,0.656z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#72F238",
    cx: 10.344,
    cy: 10.156,
    r: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIveGreenIcon);
export default __webpack_public_path__ + "static/media/ive-green-icon.e70a3c084da6a09eef60c0204c002a67.svg";
export { ForwardRef as ReactComponent };